import { useState, FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { Particles } from '../components/Particles';
import { authApi } from '../lib/api';

export function Register() {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [terms, setTerms] = useState(false);
  const [message, setMessage] = useState<{ text: string; type: 'success' | 'error' | 'info' } | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [passwordError, setPasswordError] = useState(false);

  const showMessage = (text: string, type: 'success' | 'error' | 'info') => {
    setMessage({ text, type });
    setTimeout(() => setMessage(null), 6000);
  };

  const handleConfirmPasswordChange = (value: string) => {
    setConfirmPassword(value);
    if (value !== password) {
      setPasswordError(true);
    } else {
      setPasswordError(false);
    }
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    // Validações
    if (!fullName || !email || !password || !confirmPassword) {
      showMessage('Por favor, preencha todos os campos.', 'error');
      return;
    }

    if (password !== confirmPassword) {
      showMessage('As senhas não coincidem.', 'error');
      setPasswordError(true);
      return;
    }

    if (password.length < 8) {
      showMessage('A senha deve ter no mínimo 8 caracteres.', 'error');
      return;
    }

    if (!terms) {
      showMessage('Você deve concordar com os Termos de Uso.', 'error');
      return;
    }

    setIsLoading(true);

    try {
      await authApi.register({
        email,
        password,
        full_name: fullName,
      });

      showMessage(
        'Conta criada com sucesso! Verifique seu email para confirmar o cadastro e ativar sua conta.',
        'success'
      );

      // Redirecionar para login com mensagem
      setTimeout(() => {
        window.location.href = '/login?message=check_email';
      }, 3000);
    } catch (error: any) {
      console.error('Erro no registro:', error);

      let errorMessage = 'Erro ao criar conta. Tente novamente.';

      if (error?.response?.status === 400) {
        errorMessage = error.response?.data?.detail || 'Dados inválidos. Verifique e tente novamente.';
      } else if (error?.response?.status === 409) {
        errorMessage = 'Este email já está cadastrado. Faça login ou recupere sua senha.';
      } else if (error?.response?.status === 422) {
        errorMessage = 'Dados inválidos. Verifique todos os campos.';
      } else if (!error?.response) {
        errorMessage = 'Não foi possível conectar ao servidor. Verifique sua conexão.';
      }

      showMessage(errorMessage, 'error');
      setIsLoading(false);
    }
  };

  return (
    <>
      <Particles />

      <div className="auth-container">
        {/* Logo */}
        <div className="auth-logo">
          <img src="/images/logo/logo.png" alt="NeuroAtleta Mindset" />
          <h1>Criar Conta</h1>
          <p>Comece sua jornada de transformação mental</p>
        </div>

        {/* Mensagens */}
        {message && (
          <div id="message-container">
            <div className={`message ${message.type}`}>{message.text}</div>
          </div>
        )}

        {/* Formulário de Registro */}
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="fullName">Nome Completo</label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              placeholder="Seu nome completo"
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
              autoComplete="name"
            />
            <span className="error-message">Por favor, insira seu nome completo</span>
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
            <span className="error-message">Email inválido</span>
          </div>

          <div className="form-group">
            <label htmlFor="password">Senha</label>
            <input
              type="password"
              id="password"
              name="password"
              placeholder="Mínimo 8 caracteres"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              autoComplete="new-password"
            />
            <span className="error-message">A senha deve ter no mínimo 8 caracteres</span>
          </div>

          <div className={`form-group ${passwordError ? 'error' : ''}`}>
            <label htmlFor="confirmPassword">Confirmar Senha</label>
            <input
              type="password"
              id="confirmPassword"
              name="confirmPassword"
              placeholder="Digite a senha novamente"
              value={confirmPassword}
              onChange={(e) => handleConfirmPasswordChange(e.target.value)}
              required
              minLength={8}
              autoComplete="new-password"
            />
            <span className="error-message">As senhas não coincidem</span>
          </div>

          <div className="checkbox-group">
            <input
              type="checkbox"
              id="terms"
              name="terms"
              checked={terms}
              onChange={(e) => setTerms(e.target.checked)}
              required
            />
            <label htmlFor="terms">
              Concordo com os <a href="/termos" target="_blank">Termos de Uso</a>
            </label>
          </div>

          <button type="submit" className="btn-primary" disabled={isLoading}>
            {isLoading ? (
              <>
                <span className="spinner"></span> Criando conta...
              </>
            ) : (
              'Criar Conta'
            )}
          </button>
        </form>

        {/* Links */}
        <div className="auth-links">
          <div className="divider">
            <span>ou</span>
          </div>
          <Link to="/login" className="auth-link">
            Já tem uma conta? <strong>Entrar</strong>
          </Link>
        </div>

        {/* Voltar para home */}
        <div style={{ marginTop: '2rem', textAlign: 'center' }}>
          <a href="https://neuroatletamindset.com/" className="back-link">
            ← Voltar para o site
          </a>
        </div>
      </div>
    </>
  );
}
